<template>
  <div class="drawrule">
    <div class="title">
      <img src="@/images/drawrule/title.png" alt="" />
    </div>
    <!-- <div class="date">活动时间：2021年3月28日-9月29日</div> -->
    <div class="list" v-html="activity.fashion">
      <!-- <div class="img">
        <img src="@/images/drawrule/bor.png" />
        <span>1</span>
      </div>
      <div class="text"></div> -->
    </div>
  </div>
</template>

<script>
import { drawrule } from "@/api/draw.js";
export default {
  name: "drawrule",
  data() {
    return {
      activity: null,
    };
  },
  created() {
	  if(this.$route.query.type == 2){
		  this.activity = this.$route.query.item;
	  }
	  else
	  {
		  this.getData(this.$cookies.get("internetBarId"));
	  }
  },
  methods: {
    async getData(internetBarId) {
      const data = await drawrule({ internetBarId });
      console.log(data);
      if (data.code == 200) {
        this.activity = data.data.activity;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.drawrule {
  text-align: left;
  box-sizing: border-box;
  padding: 30px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../../../images/drawrule/bg.png");
  background-size: 100% 100%;
  .title {
    width: 160px;
    height: 24px;
    margin: 0 auto;
    margin-top: 14px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .date {
    margin-top: 37.5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .list {
    margin-top: 23px;
    // display: flex;
    padding-top: 5px;
    box-sizing: border-box;
    font-size: 14px;
    overflow-y: auto;
    max-height: 90%;
    align-items: center;
    justify-content: space-between;
   
    .img {
      width: 22px;
      height: 22px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .text {
      flex: 1;
    }
  }
}
</style>
